// extracted by mini-css-extract-plugin
export default {"FilterSwitch":"styles_FilterSwitch__ImvqZ","option":"styles_option__R2CJA","active":"styles_active__Re4u2"};